<div style="margin-top: 10px;">
  <form [formGroup]="vesselVoyageForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row" style="margin-top: 20px;">
          @if (addPermission) {
            <a class="__add_client" (click)="openVesselVoyageForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Vessel Voyage
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
            <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)">
              <ng-container matColumnDef="vesselName">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Vessel Name</span>
                    <input placeholder="Search by Vessel Name" type="search" matInput
                      autocomplete="off" formControlName="vesselId" class="mat-input-custom">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.vesselName}}</td>
                </ng-container>
                <ng-container matColumnDef="voyageNo">
                  <th mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>Voyage No</span>
                      <input placeholder="Search by Voyage No" type="search" matInput
                        autocomplete="off" formControlName="voyageNo" class="mat-input-custom">
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.voyageNo}}</td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>
                      <span class="mat-sort-header-content" >Action</span></th>
                      <td class="__action_row" mat-cell *matCellDef="let element">
                        <span class="__action_edit_icon" (click)="openVesselVoyageForm(element.id)">
                          <mat-icon>create</mat-icon>
                        </span>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="vesselVoyageColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: vesselVoyageColumns;"></tr>
                  </table>
                </div>
              }
            </mat-card-content>
          </mat-card>
          @if (viewPermission) {
            <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalVesselVoyage" showFirstLastButtons></mat-paginator>
          }
        </form>
      </div>



